import { mapCanBeSold } from './mapCanBeSold';
import { mapCanBeSubscribed } from './mapCanBeSubscribed';
export const mapHasAutoSubscription = labels => !mapCanBeSold(labels) && mapCanBeSubscribed(labels);
//# sourceMappingURL=mapHasAutoSubscription.js.map